export default __webpack_public_path__ + "static/NotoSans-Black-4a2324b5d2997bf513b147ed9d03c6e8.ttf";